import { Controller } from "@hotwired/stimulus";
import { closeModal, parentModal } from "../../utils/misc";

export default class extends Controller {
  static targets = ["loader", "transactionsStep", "purchasesStep"];
  static outlets = ["sliding-content-workflow"];

  displayLoader() {
    this.loaderTarget.classList.remove("hidden");
  }

  bankTransactionsConfirmed() {
    this.loaderTarget.classList.add("hidden");

    if (this._hasPurchases()) {
      this._showPurchasesStep();
    } else {
      this._closeAndRefresh();
    }
  }

  purchasesConfirmed() {
    this._closeAndRefresh();
  }

  _showPurchasesStep() {
    this.slidingContentWorkflowOutlet.nextSection();
  }

  _closeAndRefresh() {
    const modalId = parentModal(this.element).id;
    closeModal(modalId);
    document.dispatchEvent(new CustomEvent("shareholdersAccount:confirmed"));
  }

  _hasPurchases() {
    return this.hasPurchasesStepTarget;
  }
}
